module.exports = __webpack_public_path__ + "img/depmap_svg_V167.19607431.svg";